@if (isLoading) {
  <kyc-skeleton />
} @else if (displayedDocument) {
  <div class="flex items-baseline justify-between">
    <div>
      @if (documentStatusesWithAvailableDownload.includes(displayedDocument.documentStatusCode)) {
        <button nxPlainButton class="text-left" (click)="downloadDocument(dui(), displayedDocument.fileName)">
          <nx-file-upload-name [name]="displayedDocument.fileName" class="nx-font-weight-bold" />
        </button>
      } @else {
        <nx-file-upload-name [name]="displayedDocument.fileName" />
      }
    </div>
    <div class="flex items-center">
      <nx-popover #documentPopover>{{ statusConfig?.i18n ?? '' | translate }}</nx-popover>
      <div>{{ formatDate(displayedDocument.creationDateTime) }}</div>
      @if (isPolling) {
        <div class="ml-2.5"><nx-spinner data-testid="document-status-spinner" /></div>
      } @else {
        <div [nxPopoverTriggerFor]="documentPopover" nxPopoverTrigger="hover">
          @if (statusConfig?.iconType; as iconType) {
            @if (iconType === 'pending') {
              <div class="ml-2.5"><nx-icon name="product-hourglass" size="s" /></div>
            } @else {
              <div class="ml-2.5"><nx-status-icon [type]="iconType" size="s" /></div>
            }
          }
        </div>
      }
    </div>
  </div>
}
